import React, {
  FC, useEffect, useRef, useState,
} from 'react';
import { RowCenter, Column, ColumnCenter } from './Styles';
import Dropdown from '../../../../../../components/Dropdown';
import { greenTopArrow } from '../../../../../../assets/base64Images/ai/greenTopArrow';
import { greenDownArrow } from '../../../../../../assets/base64Images/ai/greenDownArrow';
import { blackDownArrow } from '../../../../../../assets/base64Images/ai/blackDownArrow';
import Button from './Button';
import { lang, monthEnglish } from '../../../../../../lib/utils/utils';

const DatetimeModal: FC<Props> = ({
  callback,
  y,
}) => {
  const divRef = useRef<any>();
  const dateEnRef = useRef<any>();
  const dateZhRef = useRef<any>();
  const monthEnRef = useRef<any>();
  const monthZhRef = useRef<any>();
  const yearEnRef = useRef<any>();
  const yearZhRef = useRef<any>();
  const amEnRef = useRef<any>();
  const amZhRef = useRef<any>();
  const pmEnRef = useRef<any>();
  const pmZhRef = useRef<any>();
  const btnTxtEnRef = useRef<any>();
  const btnTxtZhRef = useRef<any>();

  const width = 319;
  const [height, setHeight] = useState<number>(0);
  const [day, setDay] = useState<number>(new Date().getDate());
  const [month, setMonth] = useState<number>(new Date().getMonth() + 1);
  const [year, setYear] = useState<number>(new Date().getFullYear());
  const [hour, setHour] = useState<number>(new Date().getHours());
  const [minute, setMinute] = useState<number>(new Date().getMinutes());
  const [time, setTime] = useState<string>(new Date().getHours() < 12 ? 'am' : 'pm');

  const [dayOptions, setDayOptions] = useState<{ key: number; value: string }[]>([]);
  const [monthOptions, setMonthOptions] = useState<{ key: number; value: string }[]>([]);
  const [yearOptions, setYearOptions] = useState<{ key: number; value: string }[]>([]);

  useEffect(() => {
    const interval = setInterval(() => {
      const langValue = lang(dateEnRef, dateZhRef);
      if (langValue === dateEnRef) {
        dateEnRef.current.style.display = 'block';
        monthEnRef.current.style.display = 'block';
        yearEnRef.current.style.display = 'block';
        amEnRef.current.style.display = 'block';
        pmEnRef.current.style.display = 'block';
        btnTxtEnRef.current.style.display = 'block';

        dateZhRef.current.style.display = 'none';
        monthZhRef.current.style.display = 'none';
        yearZhRef.current.style.display = 'none';
        amZhRef.current.style.display = 'none';
        pmZhRef.current.style.display = 'none';
        btnTxtZhRef.current.style.display = 'none';
      }
      else {
        dateEnRef.current.style.display = 'none';
        monthEnRef.current.style.display = 'none';
        yearEnRef.current.style.display = 'none';
        amEnRef.current.style.display = 'none';
        pmEnRef.current.style.display = 'none';
        btnTxtEnRef.current.style.display = 'none';

        dateZhRef.current.style.display = 'block';
        monthZhRef.current.style.display = 'block';
        yearZhRef.current.style.display = 'block';
        amZhRef.current.style.display = 'block';
        pmZhRef.current.style.display = 'block';
        btnTxtZhRef.current.style.display = 'block';
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setTime(hour < 12 ? 'am' : 'pm');
  }, [hour]);

  useEffect(() => {
    setHeight(divRef.current.offsetHeight);
  }, []);

  useEffect(() => {
    const years = [];
    for (let i = year - 5; i <= year; i += 1) {
      years.push({ key: i, value: i.toString() });
    }
    setYearOptions(years);

    const months = [];
    for (let i = 1; i <= 12; i += 1) {
      months.push({ key: i, value: lang(monthEnglish[i - 1], i) });
    }
    setMonthOptions(months);

    const days = [];
    const endDate = new Date(year, month, 0).getDate();
    for (let i = 1; i <= endDate; i += 1) {
      days.push({ key: i, value: i.toString() });
    }
    setDayOptions(days);
  }, []);

  useEffect(() => {
    const days = [];
    const endDate = new Date(year, month, 0).getDate();
    for (let i = 1; i <= endDate; i += 1) {
      days.push({ key: i, value: i.toString() });
    }
    setDayOptions(days);
  }, [month]);

  /**
   * 日期下拉
   */
  const getDateSelect = () => {
    const titleStyle = { fontSize: 14, fontWeight: 400, color: '#11202B', opacity: 0.4 };
    const selectStyle = { width: 85, height: 35, background: '#FFFFFF', borderRadius: 4, border: '1px solid #F7F7F7', marginTop: 7, fontFamily: 'Squad-Regular, Squad', fontSize: 16, fontWeight: 400, color: '#11202B' };
    return (
      <RowCenter style={{ marginTop: 20 }}>
        {/* 日 */}
        <Column>
          <div style={titleStyle}>
            <div style={{ display: 'none', fontFamily: 'Squad-Regular, Squad' }} ref={dateEnRef}>
              Date
            </div>
            <div style={{ display: 'none', fontFamily: 'PingFangSC-Regular, PingFang SC' }} ref={dateZhRef}>
              日期
            </div>
          </div>
          <Dropdown
            placeholder={'All'}
            options={dayOptions}
            selected={dayOptions.filter(({ key }) => key === day)}
            style={selectStyle}
            valueField="key"
            labelField="value"
            itemTextColor={'#11202B'}
            itemPaddingTop={'10px'}
            itemPaddingBottom={'10px'}
            dropdownHandleRenderer={() => <img src={blackDownArrow} style={{ width: 10, height: 7 }} />}
            onChange={(val) => {
              if (val.length > 0) {
                setDay(val[0].key);
              }
            }}
          />
        </Column>
        {/* 月 */}
        <Column style={{ marginLeft: 6 }}>
          <div style={titleStyle}>
            <div style={{ display: 'none', fontFamily: 'Squad-Regular, Squad' }} ref={monthEnRef}>
              Month
            </div>
            <div style={{ display: 'none', fontFamily: 'PingFangSC-Regular, PingFang SC' }} ref={monthZhRef}>
              月份
            </div>
          </div>
          <Dropdown
            placeholder={'All'}
            options={monthOptions}
            selected={monthOptions.filter(({ key }) => key === month)}
            style={selectStyle}
            valueField="key"
            labelField="value"
            itemTextColor={'#11202B'}
            itemPaddingTop={'10px'}
            itemPaddingBottom={'10px'}
            dropdownHandleRenderer={() => <img src={blackDownArrow} style={{ width: 10, height: 7 }} />}
            onChange={(val) => {
              if (val.length > 0) {
                setMonth(val[0].key);
              }
            }}
          />
        </Column>
        {/* 年 */}
        <Column style={{ marginLeft: 6 }}>
          <div style={titleStyle}>
            <div style={{ display: 'none', fontFamily: 'Squad-Regular, Squad' }} ref={yearEnRef}>
              Year
            </div>
            <div style={{ display: 'none', fontFamily: 'PingFangSC-Regular, PingFang SC' }} ref={yearZhRef}>
              年份
            </div>
          </div>
          <Dropdown
            placeholder={'All'}
            options={yearOptions}
            selected={yearOptions.filter(({ key }) => key === year)}
            style={selectStyle}
            valueField="key"
            labelField="value"
            itemTextColor={'#11202B'}
            itemPaddingTop={'10px'}
            itemPaddingBottom={'10px'}
            dropdownHandleRenderer={() => <img src={blackDownArrow} style={{ width: 10, height: 7 }} />}
            onChange={(val) => {
              if (val.length > 0) {
                setYear(val[0].key);
              }
            }}
          />
        </Column>
      </RowCenter>
    );
  };

  /**
   * 时间选择
   */
  const getTimeSelect = () => {
    const boxStyle: any = { width: 85, height: 94, background: '#F7F7F7', borderRadius: 6 };
    const numStyle: any = { fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', fontSize: 30, color: '#11202B', paddingTop: 10, paddingBottom: 10 };
    const greenArrowStyle: any = { width: 18, height: 13 };
    return (
      <Column>
        <RowCenter>
          {/* 小时 */}
          <ColumnCenter style={boxStyle}>
            <img src={greenTopArrow} style={greenArrowStyle} />
            <div style={numStyle}>
              {
                hour > 12 ?
                  (hour - 12) < 10 ? '0' + (hour - 12) : hour - 12 :
                  hour < 10 ? '0' + hour : hour
              }
            </div>
            <img src={greenDownArrow} style={greenArrowStyle} />
          </ColumnCenter>
          <ColumnCenter style={{ marginLeft: 11, marginRight: 11 }}>
            <div style={{ width: 5, height: 5, borderRadius: 50, background: '#11202B' }} />
            <div style={{ width: 5, height: 5, borderRadius: 50, background: '#11202B', marginTop: 20 }} />
          </ColumnCenter>
          {/* 分钟 */}
          <ColumnCenter style={boxStyle}>
            <img src={greenTopArrow} style={greenArrowStyle} />
            <div style={numStyle}>
              {
                minute < 10 ? '0' + minute : minute
              }
            </div>
            <img src={greenDownArrow} style={greenArrowStyle} />
          </ColumnCenter>
        </RowCenter>

        {/* 加大点击区域 */}
        <RowCenter>
          <ColumnCenter style={{ ...boxStyle, opacity: 0, marginTop: -boxStyle.height }}>
            {/* 点击小时增加 */}
            <div
              style={{ width: boxStyle.width, height: boxStyle.height / 2 }}
              onClick={() => {
                if (hour >= 23) {
                  setHour(0);
                }
                else {
                  setHour(hour + 1);
                }
              }}
            />
            {/* 点击小时减少 */}
            <div
              style={{ width: boxStyle.width, height: boxStyle.height / 2 }}
              onClick={() => {
                if (hour <= 0) {
                  setHour(23);
                }
                else {
                  setHour(hour - 1);
                }
              }}
            />
          </ColumnCenter>
          <ColumnCenter style={{ ...boxStyle, marginLeft: 27, opacity: 0, marginTop: -boxStyle.height }}>
            {/* 点击分钟增加 */}
            <div
              style={{ width: boxStyle.width, height: boxStyle.height / 2 }}
              onClick={() => {
                if (minute >= 59) {
                  setMinute(0);
                }
                else {
                  setMinute(minute + 1);
                }
              }}
            />
            {/* 点击分钟减少 */}
            <div
              style={{ width: boxStyle.width, height: boxStyle.height / 2 }}
              onClick={() => {
                if (minute <= 0) {
                  setMinute(59);
                }
                else {
                  setMinute(minute - 1);
                }
              }}
            />
          </ColumnCenter>
        </RowCenter>
      </Column>
    );
  };

  /**
   * 上午或下午
   */
  const getAMOrPM = () => {
    const amStyle: any = { width: 50, height: 30, background: time === 'am' ? '#00B595' : '#FFFFFF', border: time === 'am' ? '1px solid #00B595' : '1px solid #D0D0D0', borderRadius: '4px 4px 0px 0px', borderBottom: 'none', color: time === 'am' ? '#FFFFFF' : '#11202B' };
    const pmStyle: any = { width: 50, height: 30, background: time === 'pm' ? '#00B595' : '#FFFFFF', border: time === 'pm' ? '1px solid #00B595' : '1px solid #D0D0D0', borderRadius: '0px 0px 4px 4px', borderTop: 'none', color: time === 'pm' ? '#FFFFFF' : '#11202B' };
    return (
      <Column style={{ marginLeft: 19 }}>
        <ColumnCenter>
          <ColumnCenter style={amStyle}>
            <div style={{ display: 'none', fontFamily: 'Squad-SemiBold, Squad', fontWeight: 600, fontSize: 16 }} ref={amEnRef}>
              AM
            </div>
            <div style={{ display: 'none', fontFamily: 'PingFangSC-Medium, PingFang SC', fontWeight: 500, fontSize: 14 }} ref={amZhRef}>
              上午
            </div>
          </ColumnCenter>
          <ColumnCenter style={pmStyle}>
            <div style={{ display: 'none', fontFamily: 'Squad-SemiBold, Squad', fontWeight: 600, fontSize: 16 }} ref={pmEnRef}>
              PM
            </div>
            <div style={{ display: 'none', fontFamily: 'PingFangSC-Medium, PingFang SC', fontWeight: 500, fontSize: 14 }} ref={pmZhRef}>
              下午
            </div>
          </ColumnCenter>
        </ColumnCenter>

        <ColumnCenter style={{ width: amStyle.width + 2, opacity: 0, marginTop: -(amStyle.height + 2) * 2 }}>
          {/* 点击AM */}
          <div
            style={{ width: amStyle.width + 2, height: amStyle.height + 2 }}
            onClick={() => {
              if (time === 'pm') {
                setTime('am');
                setHour(hour - 12);
              }
            }}
          />
          {/* 点击分钟减少 */}
          <div
            style={{ width: pmStyle.width + 2, height: pmStyle.height + 2 }}
            onClick={() => {
              if (time === 'am') {
                setTime('pm');
                setHour(hour + 12);
              }
            }}
          />
        </ColumnCenter>
      </Column>
    );
  };

  return (
    <div ref={divRef} style={{ position: 'absolute', top: y - height }}>
      <Column style={{ width, backgroundColor: '#FFFFFF', boxShadow: '0px 2px 30px 0px rgba(0,0,0,0.05)', borderRadius: 16 }}>
        {/* 日/月/年 */}
        {getDateSelect()}

        <RowCenter style={{ marginTop: 18 }}>
          {/* 时间选择 */}
          {getTimeSelect()}
          {/* 上午或下午 */}
          {getAMOrPM()}
        </RowCenter>

        {/* 分隔线 */}
        <div style={{ width: '100%', height: 1, background: '#F7F7F7', marginTop: 12 }} />

        <RowCenter style={{ marginTop: 12 }}>
          <Button
            style={{
              width: 267,
              height: 43,
              background: '#11202B',
              borderRadius: 22,
              paddingLeft: 0,
              paddingRight: 0,
              color: '#FFFFFF',
            }}
            callback={() => {
              if (year != null && month != null && day != null && hour != null && minute != null) {
                const mon = month < 10 ? '0' + month : month;
                const d = day < 10 ? '0' + day : day;
                const h = hour < 10 ? '0' + hour : hour;
                const min = minute < 10 ? '0' + minute : minute;
                callback(year + '-' + mon + '-' + d + ' ' + h + ':' + min + ':00');
              }
            }}
          >
            <div style={{ display: 'none', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', fontSize: 16 }} ref={btnTxtEnRef}>
              Done
            </div>
            <div style={{ display: 'none', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, fontSize: 16 }} ref={btnTxtZhRef}>
              完成
            </div>
          </Button>
        </RowCenter>
      </Column>
      {/* 弹窗底部的倒三角 */}
      <div style={{ height: 37 }}>
        <div
          style={{
            marginTop: 0,
            marginLeft: 40,
            width: 0,
            height: 0,
            borderLeft: '13px solid transparent',
            borderRight: '13px solid transparent',
            borderTop: '11px solid #FFFFFF',
          }}
        />
      </div>
    </div>
  );
};

export interface Props {
  callback: (datetime: string) => void;
  y: number;
}

export default DatetimeModal;
